import { render, staticRenderFns } from "./DataKomerce.vue?vue&type=template&id=784a403b&"
import script from "./DataKomerce.vue?vue&type=script&lang=js&"
export * from "./DataKomerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports